export const PROJECT_TYPES = [
  { value: 'film', label: 'Feature Film' },
  { value: 'short_film', label: 'Short Film' },
  { value: 'student_film', label: 'Student Film' },
  { value: 'tv', label: 'Television' },
  { value: 'documentary', label: 'Documentary' },
  { value: 'reality_factual', label: 'Reality / Factual Entertainment' },
  { value: 'theatre', label: 'Theatre' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'corporate_training', label: 'Corporate / Training Film' },
  { value: 'music_video', label: 'Music Video' },
  { value: 'web_series', label: 'Web Series' },
  { value: 'vertical_drama', label: 'Vertical Drama / Microdrama' },
  { value: 'online_content', label: 'Online / Streaming Content' },
  { value: 'social_media', label: 'Social Media / Branded Content' },
  { value: 'voice_over', label: 'Voice Over' },
  { value: 'radio_podcast', label: 'Radio / Podcast' },
  { value: 'animation', label: 'Animation' },
  { value: 'video_game', label: 'Video Game' },
  { value: 'motion_capture', label: 'Motion / Performance Capture' },
  { value: 'photography', label: 'Photography / Stills' },
  { value: 'modelling', label: 'Modelling / Fashion' },
  { value: 'live_event', label: 'Live Event' },
  { value: 'immersive', label: 'Immersive / Experiential' },
  { value: 'other', label: 'Other' },
];

export const PAY_TYPES = [
  { value: 'paid', label: 'Paid' },
  { value: 'day_rate', label: 'Day Rate' },
  { value: 'hourly', label: 'Hourly Rate' },
  { value: 'fixed_fee', label: 'Fixed Fee' },
  { value: 'paid_plus_expenses', label: 'Paid + Expenses' },
  { value: 'buyout_usage', label: 'Buyout / Usage Fee' },
  { value: 'expenses_only', label: 'Expenses Only' },
  { value: 'low_budget', label: 'Low Budget / Honorarium' },
  { value: 'deferred', label: 'Deferred Payment' },
  { value: 'profit_share', label: 'Profit Share / Backend' },
  { value: 'unpaid', label: 'Unpaid / Collaboration' },
  { value: 'volunteer_charity', label: 'Volunteer / Charity' },
  { value: 'negotiable', label: 'Negotiable' },
  { value: 'tbd', label: 'To Be Confirmed' },
];

export const APPLICATION_ROUTES = [
  {
    value: 'internal',
    label: 'Apply through Casting Calls UK',
    shortLabel: 'CCUK Applicant Manager',
    description: 'Recommended. Applications go straight to your Applicant Manager so you can review, shortlist, reject and message talent in one place.',
  },
  {
    value: 'email',
    label: 'Apply by email',
    shortLabel: 'Email',
    description: 'Applicants are shown an email button after signing in and send their application to the address you provide.',
  },
  {
    value: 'external_url',
    label: 'Apply using an external link',
    shortLabel: 'External link',
    description: 'Applicants are sent to your external form, website or application portal after signing in.',
  },
];

export const PROJECT_TYPE_LABELS = Object.fromEntries(PROJECT_TYPES.map((item) => [item.value, item.label]));
export const PAY_TYPE_LABELS = Object.fromEntries(PAY_TYPES.map((item) => [item.value, item.label]));
export const APPLICATION_ROUTE_LABELS = Object.fromEntries(APPLICATION_ROUTES.map((item) => [item.value, item.shortLabel]));

export function normaliseCastingImages(call = {}) {
  const values = Array.isArray(call.image_urls) ? call.image_urls : [];
  const merged = [...values, call.flyer_url].filter((value) => typeof value === 'string' && value.trim());
  return Array.from(new Set(merged)).slice(0, 5);
}
